import { render, staticRenderFns } from "./ContentUZ.vue?vue&type=template&id=ba6f99a0"
import script from "./ContentUZ.vue?vue&type=script&lang=js"
export * from "./ContentUZ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports